// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"36168e1a","314":"99c26dc7","383":"f716ed49","495":"e7e14662","533":"146833be","688":"320c6902","808":"c76126fc"}[chunkId] + ".chunk.js";
};